import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import fanyiPic from '@/assets/fanyi.png';
import Sortable from 'sortablejs';
import { getCategoryIdAndNameList, getCategoryListByParentId, updateCategoryIndex, deleteCategory, addCategory, updateCategoryInfo, getCategoryDetail } from '@/services/product/category';
export default {
  name: 'Classification',
  i18n: require('./i18n-category'),
  components: {},
  data: function data() {
    var _this = this;
    /* 上传原产地图片验证 */
    var categoryPicValidate = function categoryPicValidate(rule, value, callback) {
      if (_this.datavalue.picturePath == null || _this.datavalue.picturePath == '') {
        callback(new Error(_this.$t('public.uploadPictureProp')));
      } else {
        callback();
      }
    };
    return {
      updateLoading: false,
      saveLoading: false,
      updateData: {
        type: 4
      },
      action: process.env.VUE_APP_API_BASE_URL + "/common/upload/",
      imageUrl: '',
      level: 0,
      categoryName: '',
      nameErr: this.$t('classification.categorynameprop'),
      categoryLangList: [],
      /* 默认语言对 */
      defaultLangObj: {},
      /* 语言list */
      langList: [],
      defaultSelectedKeys: [],
      //左边树形结构
      leftDateList: [],
      //默认展开的父级
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: ['0'],
      selectedKeys: [],
      oneshowFY: true,
      threehowFY: false,
      twoshowFY: false,
      fanyiPic: fanyiPic,
      loading: false,
      //新建，编辑的时候需要用到model
      datavalue: {
        id: '',
        parentId: 0,
        picturePath: "",
        list: [],
        showFlag: 0,
        currentLevel: 0,
        parentName: ''
      },
      dialogStatus: '',
      textMap: {
        //新建/修改title
        update: this.$t('classification.editclassification'),
        create: this.$t('classification.newclassification'),
        createfirst: this.$t('classification.addfirstcategory')
      },
      visible: false,
      //新建/修改 显示
      columns: [{
        title: this.$t('classification.serialnumber'),
        dataIndex: 'sortIndex',
        key: 'sortIndex',
        width: '10%'
      }, {
        dataIndex: 'categoryName',
        key: 'categoryName',
        slots: {
          title: 'classifytitle' //自定义标头
        },
        scopedSlots: {
          customRender: 'classifyname' //自定义表格里面的内容
        },
        ellipsis: true,
        width: '20%'
      },
      // {
      // 	dataIndex: 'showFlag',
      // 	key: 'showFlag',
      // 	slots: {
      // 		title: 'showFlagTitle' 
      // 	},
      // 	scopedSlots: {
      // 		customRender: 'showFlagConent', 
      // 	},
      // 	className: 'column-showflag',
      // 	ellipsis: true,
      // 	width: '15%',
      // },
      {
        title: this.$t('classification.goodsnum'),
        dataIndex: 'productQuantity',
        key: 'productQuantity',
        scopedSlots: {
          customRender: 'productQuantity'
        },
        className: 'column-goodsnum',
        //自定义样式
        width: '15%'
      }, {
        title: this.$t('classification.updatetime'),
        dataIndex: 'lastUpdatedTime',
        key: 'lastUpdatedTime',
        width: '25%'
      }, {
        title: this.$t('classification.operation'),
        dataIndex: 'action',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        width: '15%'
      }],
      //列表数据
      classifyList: [],
      isTableLoading: false,
      rules: {
        categoryPic: [{
          required: true,
          validator: categoryPicValidate,
          trigger: 'change'
        }]
      },
      updateCategoryIndexLoading: false
    };
  },
  computed: {
    synchronizedStockTimeStr: function synchronizedStockTimeStr() {
      return this.$t('classification.remindcontent');
    },
    uploadLimit: function uploadLimit() {
      return localStorage.uploadLimit;
    }
  },
  watch: {
    value: function value(_value) {
      // console.log(value);
    },
    checkedKeys: function checkedKeys(val) {
      // console.log('onCheck', val);
    }
  },
  mounted: function mounted() {
    console.log(123123);
    this.getLfetList();
    this.getInitialValue();
  },
  methods: {
    showFYBtn: function showFYBtn(categoryObj) {
      var self = this;
      var categoryNameListClone = self.datavalue.list;
      var _iterator = _createForOfIteratorHelper(categoryNameListClone),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var one = _step.value;
          one.showNameFY = false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.datavalue.list = categoryNameListClone;
      categoryObj.showNameFY = true;
    },
    /* 获取localStorage里面的默认语言 和系统设置中存的语言list */getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator2 = _createForOfIteratorHelper(self.langList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          var nameObj = {};
          //因为编辑的是否需要id
          nameObj.id = '';
          nameObj.titleName = self.$t('classification.categoryname') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //分类名称
          nameObj.name = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          nameObj.showNameFY = false;
          self.categoryLangList.push(nameObj);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      self.datavalue.list = _.cloneDeep(self.categoryLangList);
    },
    //获取左侧的列表
    getLfetList: function getLfetList() {
      var _this2 = this;
      getCategoryIdAndNameList().then(function (res) {
        _this2.leftDateList = [{
          categoryName: _this2.$t('classification.allCla'),
          id: '0',
          currentLevel: 0,
          childrenList: res.data.data
        }];
        _this2.expandedKeys = ['0'];
        //设置默认选中所有分类
        _this2.defaultSelectedKeys = ['0'],
        //页面初始化，默认获取所有分类底下的一级分裂
        _this2.getRightList(0);
      });
    },
    onClose: function onClose(e) {},
    /* 拖拽排序 */setSort: function setSort() {
      var _this3 = this;
      var el = document.querySelectorAll('.ant-table-body > table > tbody')[0];
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        setData: function setData(dataTransfer) {
          dataTransfer.setData('Text', '');
        },
        onEnd: function onEnd(evt) {
          var targetRow = _this3.classifyList.splice(evt.oldIndex, 1)[0];
          _this3.classifyList.splice(evt.newIndex, 0, targetRow);
          //重新设置序号
          var processorderDatalist = [];
          for (var i = 0; i < _this3.classifyList.length; i++) {
            var processorderData = new Object();
            processorderData.id = _this3.classifyList[i].id + "";
            processorderData.categoryName = _this3.classifyList[i].categoryName;
            processorderData.productQuantity = _this3.classifyList[i].productQuantity;
            processorderData.lastUpdatedTime = _this3.classifyList[i].lastUpdatedTime;
            processorderData.showFlag = _this3.classifyList[i].showFlag + "";
            processorderData.parentId = _this3.classifyList[i].parentId + "";
            processorderData.sortIndex = i + 1 + "";
            processorderDatalist.push(processorderData);
          }
          // 调用接口，将变换后的顺序进行保存
          if (_this3.updateCategoryIndexLoading) return;
          _this3.updateCategoryIndexLoading = true;
          updateCategoryIndex(processorderDatalist).then(function (response) {
            if (response.data.code == 200) {
              _this3.$message.success(_this3.$t('public.updateSuccessfully'));
              //如果拖拽排序的是所有分类，那么需要刷新左侧的列表
              if (_this3.defaultSelectedKeys[0] == 0) {
                _this3.getLfetList();
              } else {
                //刷新右侧的树形结构
                _this3.getRightList(_this3.selectedKeys[0]);
              }
            }
          }).finally(function () {
            _this3.updateCategoryIndexLoading = false;
          });
        }
      });
    },
    onExpand: function onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck: function onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    /* 添加按钮 */addModal: function addModal() {
      if (this.selectedKeys[0] != null && this.selectedKeys[0] != undefined) {
        this.dialogStatus = 'create';
      } else {
        this.selectedKeys = [0];
        this.dialogStatus = 'createfirst';
      }
      this.loading = false;
      this.visible = true;
      this.saveLoading = false;
      this.resetdatavalue();
    },
    resetdatavalue: function resetdatavalue() {
      this.datavalue = {
        id: '',
        parentId: this.selectedKeys[0],
        picturePath: "",
        list: _.cloneDeep(this.categoryLangList),
        showFlag: 0,
        currentLevel: this.level,
        parentName: this.categoryName
      };
      this.imageUrl = '';
    },
    //点击左侧树形结构，获取一级分类下面的子级
    onSelect: function onSelect(selectedKeys, e) {
      if (selectedKeys[0] != null) {
        this.getRightList(selectedKeys[0]);
      }
      this.selectedKeys = selectedKeys;
      this.defaultSelectedKeys = selectedKeys;
      //当前分类的等级，新建的时候用到
      if (e.selectedNodes.length > 0) {
        this.level = e.selectedNodes[0].data.props.currentLevel;
        this.categoryName = e.selectedNodes[0].data.props.categoryName;
      } else {
        this.level = 0;
        this.categoryName = "";
      }
    },
    /* 更具父级id获取子集列表右侧的数据 */getRightList: function getRightList(id) {
      var _this4 = this;
      this.isTableLoading = true;
      getCategoryListByParentId(Number(id)).then(function (res) {
        if (res.data.code == 200) {
          _this4.classifyList = res.data.data;
          _this4.setSort();
        }
      }).finally(function () {
        _this4.isTableLoading = false;
      });
    },
    /* 上传图片相关 */handleChange: function handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.code == 200) {
          var picurl = info.file.response.data.uploadfilepath;
          var urlpath = info.file.response.data.urlpath;
          this.datavalue.picturePath = picurl;
          this.imageUrl = urlpath + picurl;
          this.loading = false;
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('public.pictureType'));
      }
      var isLt2M = file.size / 1024 / 1024 < this.uploadLimit;
      if (!isLt2M) {
        this.$message.error(this.$t('public.pictureMax', {
          uploadLimit: this.uploadLimit
        }));
      }
      return isJpgOrPng && isLt2M;
    },
    /* 编辑按钮 */updata: function updata(record) {
      var _this5 = this;
      getCategoryDetail(record.id).then(function (response) {
        if (response.data.code == 200) {
          var dataNameList = response.data.data.categoryList;
          _this5.datavalue.id = response.data.data.id;
          _this5.datavalue.parentId = response.data.data.parentId;
          _this5.datavalue.parentName = response.data.data.parentName;
          _this5.datavalue.showFlag = response.data.data.showFlag;
          _this5.datavalue.picturePath = response.data.data.pictureUrl;
          _this5.urlHost = response.data.data.urlHost;
          _this5.imageUrl = _this5.urlHost + _this5.datavalue.picturePath;
          var newNameList = _.cloneDeep(_this5.categoryLangList);
          var _iterator3 = _createForOfIteratorHelper(newNameList),
            _step3;
          try {
            var _loop = function _loop() {
              var initial = _step3.value;
              var findObj = _.find(dataNameList, function (o) {
                return o.langId == initial.langId;
              });
              if (findObj) {
                initial.id = findObj.id;
                initial.name = findObj.categoryName;
              }
            };
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          _this5.datavalue.list = _.cloneDeep(newNameList);
          _this5.dialogStatus = 'update';
          _this5.visible = true;
          _this5.updateLoading = false;
        }
      });
    },
    /* 确定更新 */updateUser: function updateUser() {
      var _this6 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this6.updateLoading = true;
          updateCategoryInfo(_this6.datavalue).then(function (response) {
            if (response.data.code == 200) {
              if (_this6.defaultSelectedKeys[0] == 0) {
                _this6.getLfetList();
              } else {
                //刷新右侧的树形结构
                _this6.getRightList(_this6.selectedKeys[0]);
              }
              _this6.$message.success(_this6.$t('public.updateSuccessfully'));
              _this6.visible = false;
              // this.getList()
            } else {
              _this6.updateLoading = false;
            }
          }).finally(function () {
            _this6.updateLoading = false;
          });
        }
      });
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.visible = false;
      this.resetdatavalue();
    },
    cliknum: function cliknum() {
      // alert("我是点击跳转方法")
    },
    loadData: function loadData() {},
    confirm: function confirm(id) {
      var _this7 = this;
      var self = this;
      deleteCategory(id).then(function (response) {
        if (response.data.code == 200) {
          if (_this7.defaultSelectedKeys[0] == 0) {
            _this7.getLfetList();
          } else {
            //刷新右侧的树形结构
            _this7.getRightList(_this7.selectedKeys[0]);
          }
          _this7.$message.success(_this7.$t('public.deleteSuccessfully'));
        }
      });
    },
    cancel: function cancel(e) {
      // console.log(e);
      // this.$message.error('取消删除了');
    },
    /* 确定添加 */saveCategory: function saveCategory() {
      var _this8 = this;
      var self = this;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this8.saveLoading = true;
          addCategory(self.datavalue).then(function (response) {
            if (response.data.code == 200) {
              if (_this8.defaultSelectedKeys[0] == 0) {
                _this8.getLfetList();
              } else {
                //刷新右侧的树形结构
                _this8.getRightList(_this8.selectedKeys[0]);
              }
              _this8.$message.success(_this8.$t('public.addSuccessfully'));
              _this8.visible = false;
            } else {
              _this8.saveLoading = false;
            }
          }).finally(function () {
            _this8.saveLoading = false;
          });
        }
      });
    }
  }
};